import { matchPath } from "#src/components/Router.tsx";

const preloadRegistry = new Map<
  string,
  { path: string; exact: boolean; preload: () => void }
>();

export const registerForPreload = (
  path: string,
  exact: boolean,
  component: any
) => {
  if (!component || !component.preload) return;
  const key = `${path}-${exact}`;
  if (!preloadRegistry.has(key)) {
    preloadRegistry.set(key, {
      path,
      exact,
      preload: component.preload,
    });
  }
};

export const preloadLegacyPath = (pathname: string) => {
  for (const { path, exact, preload } of preloadRegistry.values()) {
    if (matchPath(pathname, { path, exact })) {
      preload();
      // Execute all matches to support nested bundle loading (don't break here!)
    }
  }
};
